/// <amd-module name="Wit/SprintsHub/Common/ISprintsDirectoryService" />
import { Services } from "VSS/Platform/Context";
import { SprintDirectoryItem } from "Wit/DirectoryService/Client/Contracts/Directory";
import { DirectoryService, IDirectoryService } from "Wit/DirectoryService/IDirectoryService";
import { DataProviders } from "./Constants";

export interface ISprintsDirectoryService extends IDirectoryService<SprintDirectoryItem> {}

class SprintsDirectoryService extends DirectoryService<SprintDirectoryItem> implements ISprintsDirectoryService {
    protected myDirectoryDataProviderContribution = DataProviders.DirectoryDataProvider;
    protected allDirectoryDataProviderContribution = DataProviders.AllDirectoryDataProvider;
}

Services.add("ISprintsDirectoryService", { serviceFactory: SprintsDirectoryService });
